module.exports = __webpack_public_path__ + "img/rule-ar.b99f1587.png";